import { render, staticRenderFns } from "./BaseNavigation.vue?vue&type=template&id=2a6d0b92&scoped=true"
import script from "./BaseNavigation.vue?vue&type=script&lang=js"
export * from "./BaseNavigation.vue?vue&type=script&lang=js"
import style0 from "./BaseNavigation.vue?vue&type=style&index=0&id=2a6d0b92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6d0b92",
  null
  
)

export default component.exports